<template>
  <component
    :is="element"
    class="button"
    :class="[
      $blockClass(blockClass, 'button'),
      modifierClasses,
      {
        'has-state': state && stateIcon,
        [$class('active')]: state && stateIcon
      },
      { 'button--no-icon' : !icon }
    ]"
    :href="url || null"
    :type="type || null"
    :style="this.schoolColor ? { backgroundColor: this.schoolColor, borderColor: this.schoolColor, color: 'white !important' } : {}"
  >
    <span
      class="button__label"
      :class="[
        $blockClass(blockClass, 'button-label'),
        { 'button__label--no-icon': !icon },
      ]"
      v-text="label"
    />

    <span
      v-if="icon"
      class="button__icon"
      :class="$blockClass(blockClass, 'button-icon')"
      v-html="$icon(icon)"
    />

    <span
      v-if="state && stateIcon"
      class="button__state"
      :class="$blockClass(blockClass, 'button-state')"
      v-html="$icon(stateIcon)"
    />
  </component>
</template>

<script>

/**
 * Vue: Button (btn)
 * -----------------------------------------------------------------------------
 * Global interactive button element.
 * - Styles are imported in critical styles.
 * - Must be imported as <btn> as <button> is a default element.
 *
 * @param {String} [blockClass] - Block level class to apply to all elements.
 * @param {String} [customElement] - Optional override to set button element.
 * @param {String|Boolean} [icon] - Path to icon as defined in `theme-icons.liquid`.
 * @param {String} label - Button label.
 * @param {String} [modifiers] - Button modifiers in space separated list
 (secondary, light, outlined, text, block, reversed, center, small, or large).
 * @param {Boolean} [state] - Show secondary button state, replaces text and
 * default icon with `stateIcon`.
 * @param {String} [stateIcon] - Path to secondary state icon as defined in
 * `theme-icons.liquid` which is shown when `state` is true.
 * @param {String} [type] - Type of button (button or submit).
 * @param {String} [url] - URL if link.
 *
 */
export default {
  name: 'Btn',

  props: {
    blockClass: {
      type: String,
      default: '',
    },
    customElement: {
      type: String,
      default: '',
    },
    icon: {
      type: [String, Boolean],
      default: 'direction.arrow.right',
    },
    label: {
      type: String,
      default: '',
      required: true,
    },
    modifiers: {
      type: [String, Array],
      default: '',
    },
    state: {
      type: Boolean,
      default: false,
    },
    stateIcon: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      global: true,
      schoolColor: '',
    }
  },

  computed: {

    /**
     * Compute element type.
     * @returns {String}
     */
    element() {
      if (this.customElement) {
        return this.customElement
      }

      return this.url ? 'a' : 'button'
    },

    /**
     * Compute modifier classes.
     * @returns {String}
     */
    modifierClasses() {
      if (!this.modifiers) {
        return ''
      }

      let modifiers = []

      if (Array.isArray(this.modifiers)) {
        const combined =  this.modifiers.map((el) => {
          if(!el.includes(' ')) {
            return el
          }

          return el.split(' ')
        })

        modifiers = combined.flat()
      } else {
        modifiers = this.modifiers.split(' ')
      }

      return modifiers.map((modifier) => {
        return `button--${modifier}`
      }).join(' ')
    },
  },

  // beforeMount(){
  //   (async ()=>{
  //     const schoolCode = sessionStorage.getItem('sc');

  //     const getJSON = async url => {
  //       const response = await fetch(url);
  //       if(!response.ok)
  //         throw new Error(response.statusText);

  //       const data = response.json();
  //       return data;
  //     }

  //     if(schoolCode){
  //       getJSON("https://cdn.shopify.com/s/files/1/0607/1844/8811/files/schools.json?v=1704274459").then(data => {
  //         const schools = data;
  //         const school = schools.find(s => s.schoolCode.toLowerCase() === schoolCode);
  //         this.schoolColor = school.schoolPrimaryColor;
  //       }).catch(error => {
  //         console.error(error);
  //       });
  //     }
  //   })();
  // },

}
</script>
